import styled from "styled-components";

const TableRowContainer = styled.div`
  cursor: pointer;
  display: flex;
  padding: 5px 3px 5px 3px;
  align-items: ${props => props.isVisible ? "top" : "center"};
  justify-content: space-between;
  border-bottom: 1px solid #cdcdcd;
  color: #000000;
  text-decoration: none;
  
  &:hover {
    background-color: #efefef;
  }
`;

export default TableRowContainer;
